import React, { useEffect, useState, useRef, useCallback } from 'react';
import axios from './utils/axiosConfig';
import { Table, Form, Alert, Button, Modal, Badge, Card, Row, Col } from 'react-bootstrap';
import { useAuth } from './context/AuthContext'; // 確認 `useAuth` 已正確導入
import { isSuperAdmin } from './utils/superAdmin'; // 引入 isSuperAdmin 檢查工具函數
import Select from 'react-select'; // 匯入 react-select
import { downloadExcel } from './utils/excel'; // 導入 downloadExcel 函數
import useFetch from './components/useFetch'; // 自訂 Hook
import PhotoUpload from './services/PhotoUpload'; // 匯入 PhotoUpload 元件
import BatchEditTable from './components/BatchEditTable'; // 批次編輯表格組件
import Lightbox from 'react-image-lightbox'; // 匯入 Lightbox
import 'react-image-lightbox/style.css'; // 匯入 Lightbox 的樣式
import { useMediaQuery } from 'react-responsive'; // RWD 支援

function EmployeeBatch() {
  // 添加表格欄位調整的樣式和 RWD 樣式
  const tableStyles = `
    .resizable-table th {
      position: relative;
      border-right: 2px solid #ddd;
      user-select: none;
    }
    .resizable-table th:hover {
      cursor: col-resize;
    }
    .table-responsive {
      overflow-x: auto;
    }

    /* RWD: 手機版 Modal 表單樣式 */
    @media (max-width: 768px) {
      .modal .form-label {
        font-size: 16px !important;
        font-weight: bold;
        margin-bottom: 8px;
      }
      .modal .form-control,
      .modal .form-select {
        font-size: 16px !important;
        padding: 12px !important;
        min-height: 48px;
      }
      .modal .form-group,
      .modal .mb-3 {
        margin-bottom: 20px !important;
      }
      .modal-body {
        padding: 20px !important;
      }
      .modal-footer .btn {
        font-size: 16px !important;
        padding: 12px 24px !important;
        min-height: 48px;
      }
    }
  `;

  const { user } = useAuth(); // 使用 useAuth 來取得使用者資訊
  
  // 所有 useState 必須在條件語句之前
  const [tableData, setTableData] = useState([]);
  const [appellations, setAppellations] = useState([]);
  const [employees, setEmployees] = useState([]); // 新增一個狀態來儲存社友列表
  const [relationEmployees, setRelationEmployees] = useState([]); // 專門用於關連人選擇的社友列表
  
  //const [mainempOptions, setMainempOptions] = useState([]); // 儲存 mainemp 表中的類別
  const [filter, setFilter] = useState('');
  const [filterGroup, setFilterGroup] = useState('5'); // 預設篩選「5 社友」
  const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'asc' });
  const [message, setMessage] = useState('');
  //const [positions, setPositions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({ e_appellation: '',e_group: '' }); // 初始化為空物件並設置 `e_appellation` 預設值
  const [isEdit, setIsEdit] = useState(false);
  const inputRefs = useRef({}); // 儲存所有輸入框的 ref
  const [successMessage, setSuccessMessage] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [uploadStatus, setUploadStatus] = useState('');
  const [archiveModal, setArchiveModal] = useState(false);
  const [archiveData, setArchiveData] = useState({ arriveat: '' });

  // 圖片預覽 Lightbox 狀態
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState('');
  const [birthdayModal, setBirthdayModal] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState('');
  const [birthdayData, setBirthdayData] = useState([]);
  const [batchEditModal, setBatchEditModal] = useState(false);
  const [batchEditData, setBatchEditData] = useState([]);
  const [modifiedCount, setModifiedCount] = useState(0);
  
  // 貼上資料功能的狀態
  const [pasteDataModal, setPasteDataModal] = useState(false);
  const [pasteText, setPasteText] = useState('');
  const [parsedPasteData, setParsedPasteData] = useState([]);
  const [pasteProcessing, setPasteProcessing] = useState(false);

  const token = localStorage.getItem('token');

  // 響應式判斷：768px 以下為手機版
  const isMobile = useMediaQuery({ maxWidth: 768 });

  // 職位對應表 (從 societies_title 表)
  const POSITION_MAPPING = {
    '社友': 1, '社長': 2, '理事': 3, '候補理事': 4, '監事': 5,
    '候補監事': 6, '第一副社長': 7, '第二副社長': 8, '常務監事': 9,
    '秘書長': 10, '副秘書長': 11, '財務長': 12, '前社長': 13,
    '輔導社長': 14, '創社長': 15, '秘書': 17, '寶眷': 18,
    '來賓': 19, '顧問': 20, '創社輔導社長': 21, '副財務長': 22,
    '隊長': 23, '總幹事': 24, '副總幹事': 25, '會長': 26,
    '副隊長': 27, '副會長': 28, '主委': 29, '資訊長': 30
  };
  
  // 使用 useFetch 獲取資料 - 必須在條件語句之前
  const { data: mainempOptions, loading: mainempLoading } = useFetch('/mainemp', {
    headers: { Authorization: `Bearer ${token}` },
  });
  const { data: positions = [] } = useFetch('/positions', {
    headers: { Authorization: `Bearer ${token}` },
  });

  // 使用 useCallback 定義函數，這樣它們可以在 useEffect 之前使用
  const fetchRelationEmployees = useCallback(() => {
    axios
      .get('/employees/for-relation', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setRelationEmployees(response.data.data);
      })
      .catch((error) => {
        console.error('Error fetching relation employees:', error.response || error);
      });
  }, [token]);

  const fetchBirthdayList = useCallback((month) => {
    axios
      .get('/employees/birthday', {
        params: { month },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setBirthdayData(response.data.data || []);
        setBirthdayModal(true);
      })
      .catch((error) => {
        console.error('Error fetching birthday list:', error.response || error);
        alert(`獲取壽星名單失敗: ${error.response?.data?.message || error.message}`);
      });
  }, [token]);

  const handleBirthdayQuery = useCallback(() => {
    if (!selectedMonth) {
      alert('請選擇月份');
      return;
    }
    fetchBirthdayList(selectedMonth);
  }, [selectedMonth, fetchBirthdayList]);

  // 下載壽星名單Excel
  const downloadBirthdayExcel = useCallback(async () => {
    if (!birthdayData || birthdayData.length === 0) {
      alert('沒有壽星資料可下載');
      return;
    }

    try {
      // 動態導入xlsx庫
      const XLSX = await import('xlsx');
      
      // 準備Excel資料
      const excelData = birthdayData.map((person, index) => ({
        '序號': index + 1,
        '姓名': person.e_name || '',
        '社別': person.store_name || '',
        '職位': person.position_name || '',
        '生日': person.birthday_display || ''
      }));

      // 將資料轉換為工作表
      const worksheet = XLSX.utils.json_to_sheet(excelData);
      
      // 建立一個工作簿
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, `${selectedMonth}月壽星`);
      
      // 生成檔名
      const fileName = `${selectedMonth}月壽星名單_${new Date().toISOString().split('T')[0]}.xlsx`;
      
      // 生成並下載Excel檔案
      XLSX.writeFile(workbook, fileName);
      
      console.log(`✅ Excel 匯出成功：${fileName}`);
    } catch (error) {
      console.error('Excel匯出失敗:', error);
      alert('Excel匯出失敗，請稍後再試');
    }
  }, [birthdayData, selectedMonth]);

  // 批次編輯相關函數
  const handleBatchEditOpen = useCallback(() => {
    setBatchEditData([...tableData]);
    setBatchEditModal(true);
  }, [tableData]);

  const handleBatchEditDataChange = useCallback((newData) => {
    setBatchEditData(newData);
  }, []);

  const handleModifiedCountChange = useCallback((count) => {
    setModifiedCount(count);
  }, []);

  // 貼上資料處理函數 - 支援職位、組別、組別職稱
  const handleParsePasteData = useCallback(() => {
    if (!pasteText.trim()) {
      alert('請輸入要處理的資料');
      return;
    }

    const lines = pasteText.trim().split('\n');
    const parsed = [];
    const errors = [];

    lines.forEach((line, index) => {
      const trimmedLine = line.trim();
      if (!trimmedLine) return;

      // 支援多種分隔符：空白、Tab、逗號、分號
      const parts = trimmedLine.split(/[\s\t,;]+/).filter(part => part.trim());
      
      if (parts.length < 2) {
        errors.push(`第 ${index + 1} 行格式錯誤，至少需要 ID 和職位: ${line}`);
        return;
      }

      const e_id = parts[0];
      const positionName = parts[1];
      const e_set = parts[2] || null; // 組別 (可選)
      const e_set_position = parts[3] || null; // 組別職稱 (可選)

      // 驗證 e_id 是數字
      if (!/^\d+$/.test(e_id)) {
        errors.push(`第 ${index + 1} 行 ID 格式錯誤: ${e_id}`);
        return;
      }

      // 查找職位對應
      const e_position = POSITION_MAPPING[positionName];
      if (!e_position) {
        errors.push(`第 ${index + 1} 行找不到職位: ${positionName}`);
        return;
      }

      const updateData = {
        e_id: parseInt(e_id),
        positionName,
        e_position,
        lineNumber: index + 1
      };

      // 如果有提供組別，添加到更新資料中
      if (e_set) {
        updateData.e_set = e_set;
      }

      // 如果有提供組別職稱，添加到更新資料中
      if (e_set_position) {
        updateData.e_set_position = e_set_position;
      }

      parsed.push(updateData);
    });

    if (errors.length > 0) {
      alert(`解析錯誤：\n${errors.join('\n')}`);
      return;
    }

    setParsedPasteData(parsed);
    alert(`成功解析 ${parsed.length} 筆資料`);
  }, [pasteText, POSITION_MAPPING]);

  const handleExecutePasteUpdate = useCallback(async () => {
    if (parsedPasteData.length === 0) {
      alert('沒有要更新的資料');
      return;
    }

    if (!window.confirm(`確定要更新 ${parsedPasteData.length} 筆職位資料嗎？`)) {
      return;
    }

    setPasteProcessing(true);

    try {
      const updates = parsedPasteData.map(item => {
        const updateItem = {
          e_id: item.e_id,
          e_position: item.e_position
        };

        // 如果有組別，添加到更新項目
        if (item.e_set) {
          updateItem.e_set = item.e_set;
        }

        // 如果有組別職稱，添加到更新項目
        if (item.e_set_position) {
          updateItem.e_set_position = item.e_set_position;
        }

        return updateItem;
      });

      console.log('🔍 發送批量更新請求:', { updates });
      console.log('🔍 請求 URL:', '/employees/batch-update');
      console.log('🔍 完整請求 URL 應該是:', '/api/employees/batch-update');
      console.log('🔍 Token exists:', !!token);

      const response = await axios.put('/employees/batch-update', { updates });

      console.log('批量更新回應:', response.data);

      if (response.data.success) {
        const { updatedCount, errors } = response.data;
        
        let message = `批量更新完成！\n成功: ${updatedCount} 筆`;
        if (errors && errors.length > 0) {
          message += `\n失敗: ${errors.length} 筆`;
          message += `\n錯誤詳情:\n${errors.join('\n')}`;
        }
        
        alert(message);
        
        // 重新載入資料 - 直接呼叫而不依賴 useCallback
        window.location.reload();
        
        // 清空貼上資料
        setPasteText('');
        setParsedPasteData([]);
        setPasteDataModal(false);
      } else {
        alert(`更新失敗: ${response.data.message}`);
      }
    } catch (error) {
      console.error('批量更新失敗:', error);
      console.error('錯誤詳情:', error.response?.data);
      
      let errorMessage = '更新失敗';
      if (error.response?.data?.message) {
        errorMessage += `: ${error.response.data.message}`;
      } else if (error.message) {
        errorMessage += `: ${error.message}`;
      }
      
      alert(errorMessage);
    } finally {
      setPasteProcessing(false);
    }
  }, [parsedPasteData, token]);

  const handleBatchSave = useCallback(async () => {
    try {
      const modifiedRows = batchEditData.filter(row => row._isModified);
      
      if (modifiedRows.length === 0) {
        alert('沒有修改的資料');
        return;
      }

      if (!window.confirm(`確定要儲存 ${modifiedRows.length} 筆修改的資料嗎？`)) {
        return;
      }

      // 準備批次更新的資料
      const updateData = modifiedRows.map(row => {
        const { _originalIndex, _isModified, ...cleanRow } = row;
        return cleanRow;
      });

      // 調用批次更新API
      const response = await axios.put('/employees/batch-update', {
        updates: updateData
      });

      if (response.data.success) {
        alert(`成功更新 ${response.data.updatedCount} 筆資料`);
        setBatchEditModal(false);
        setModifiedCount(0);
        // 刷新頁面來重新載入資料
        window.location.reload();
      }
    } catch (error) {
      console.error('批次更新失敗:', error);
      alert(`批次更新失敗: ${error.response?.data?.message || error.message}`);
    }
  }, [batchEditData, token]);

  const handleBatchReset = useCallback(() => {
    setBatchEditData([...tableData]);
    setModifiedCount(0);
  }, [tableData]);

  const fetchPositions = useCallback(() => {
    axios
      .get('/positions', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        //setPositions(response.data);
      })
      .catch((error) => {
        console.error('Error fetching positions:', error.response || error);
      });
  }, [token]);

  const fetchData = useCallback(() => {
    axios
      .get('/employees1', {
        params: {
          filter,               // 搜索的篩選
          sortKey: sortConfig.key,
          sortDirection: sortConfig.direction,
          filterGroup,         // 狀態篩選
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        let data = response.data.data;
         
        setEmployees(data); // 將資料設置到 employees 狀態
        
        // 过滤数据
        if (filter) {
          const lowerFilter = filter.toLowerCase();
          data = data.filter((employee) =>
            Object.values(employee).some((val) =>
              String(val).toLowerCase().includes(lowerFilter)
            )
          );
        }

        // 排序数据
        if (sortConfig.key) {
          data = data.sort((a, b) => {
            if (a[sortConfig.key] < b[sortConfig.key]) {
              return sortConfig.direction === 'asc' ? -1 : 1;
            }
            if (a[sortConfig.key] > b[sortConfig.key]) {
              return sortConfig.direction === 'asc' ? 1 : -1;
            }
            return 0;
          });
        }

        setTableData(data); // 將篩選和排序後的資料設置到表格
      })
      .catch((error) => {
        console.error('Error fetching data:', error.response || error);
      });
  }, [filter, sortConfig.key, sortConfig.direction, filterGroup, token]);

  // 所有 useEffect 也必須在條件語句之前
  useEffect(() => {
    if (modalData?.e_photo) {
      setPreviewUrl(`/uploads/member/${modalData.e_photo}?t=${new Date().getTime()}`); // 使用時間戳避免快取
    } else {
      setPreviewUrl('/uploads/member/default.jpg'); // 預設圖片
    }
  }, [modalData?.e_photo]);

  useEffect(() => {
    const fetchAppellations = async () => {
      try {
        const response = await axios.get('/appellations'); // 根據你的後端路徑調整 URL
        setAppellations(response.data);
      } catch (error) {
        console.error('Error fetching appellations:', error);
      }
    };

    fetchAppellations();
  }, []);

  useEffect(() => {
    fetchData();
    fetchPositions();
  }, [fetchData, fetchPositions]);

  // 關連人列表只在組件初始化時載入一次
  useEffect(() => {
    fetchRelationEmployees(); // 獲取關連人列表
  }, [fetchRelationEmployees]);

  // 簡化權限：只有秘書能編輯
  const canEditRole = isSuperAdmin(user?.e_id) || user?.e_position === 17;
  // e_id=80 (超級管理員) 或 e_position=17 (系統管理員) 可以刪除資料
  const canDelete = isSuperAdmin(user?.e_id) || user?.e_position === 17;

  // 如果沒有權限，顯示未授權頁面
  if (!canEditRole) {
    return (
      <div className="container-fluid mt-4">
        <Alert variant="warning">
          <h4>存取被拒絕</h4>
          <p>您沒有權限存取此頁面。只有秘書(e_position=17)或特定用戶(e_id=80)才能使用社友修改功能。</p>
        </Alert>
      </div>
    );
  }

  // 原有的社友選項（用於一般用途）
  const employeeOptions = employees.map((employee) => ({
    value: employee.e_id,
    label: employee.e_name,
  }));

  // 關連人選項（獨立不受篩選影響）
  const relationEmployeeOptions = relationEmployees.map((employee) => ({
    value: employee.e_id,
    label: `${employee.e_name} (${employee.store_name})`,
  }));

  const handleSave = (id) => {
  const rowData = tableData.find((row) => row.e_id === id);
  if (!rowData) {
    console.error('Row data not found for id:', id);
    return;
  }

  if (!token) {
    setMessage('未找到驗證資訊，請重新登入');
    return;
  }

  // 準備更新請求的資料
  const payload = { ...rowData };

  // 發送更新請求
  axios
    .put(`/employees/${id}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then(() => {
      setMessage('更新成功！');
      setTableData((prevData) =>
        prevData.map((row) =>
          row.e_id === id ? { ...row, hasChanges: false, saveStatus: 'saved' } : row
        )
      );
      setTimeout(() => setMessage(''), 2000);
    })
    .catch((error) => {
      if (error.response?.status === 403) {
        setMessage(error.response.data.message);
      } else {
        console.error('Error updating data:', error);
        setMessage('更新失敗！');
      }
    });
};


  const handleInputChange = (e, id, field, newValue = null) => {
    const value = newValue !== null ? newValue : e.target.value;
    console.log(`Updating field ${field} for id ${id} with value: ${value}`);

    const updatedData = tableData.map((row) => {
      if (row.e_id === id) {
        let updatedRow = {
          ...row,
          [field]: value,
          hasChanges: true,
          saveStatus: 'unsaved',
        };
        if (field === 'position_title') {
          const selectedOption = positions.find((option) => option.s_name === value);
          console.log('Selected Option:', selectedOption);
          updatedRow.e_position = selectedOption ? selectedOption.s_id : null;
        
        
        }
        return updatedRow;
      }
      return row;
    });

    setTableData(updatedData);
  };

  

  const handleModalInputChange = (e) => {
    const { name, value } = e.target;
  
    setModalData((prevData) => {
      const updatedData = {
        ...prevData,
        [name]: value,
      };
  
      // 處理 position_title 欄位
      if (name === 'position_title') {
        const selectedPosition = positions.find((position) => position.s_name === value);
        updatedData.e_position = selectedPosition ? selectedPosition.s_id : null;
      }
  
      // 處理 e_foodType 欄位
      if (name === 'e_foodType') {
        updatedData.e_foodType = parseInt(value, 10); // 將字串轉換為整數
      }
  
      // 處理 e_sex 欄位
      if (name === 'e_sex') {
        updatedData.e_sex = parseInt(value, 10); // 將字串轉換為整數
      }
  
      return updatedData;
    });
  };
  
  
  

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const renderSortIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'asc' ? ' ↑' : ' ↓';
    }
    return '';
  };

  const handleOpenModal = (employee = null) => {
    const initialData = employee || { 
      e_name: '', 
      position_title: '', 
      e_set: '', 
      e_set_position: '', 
      e_mobile: '', 
      e_address2: '', 
      e_status: 0, 
      e_photo: '', // 確保有 e_photo 字段
      e_ssid: user?.e_ssid || '', // 新增時使用從 useAuth 中取得的 e_ssid
      e_group: '5', // 新增時預設 e_group 為 5 (社友)
      e_position: 1, // 新增時預設 e_position 為 1 (一般社友職位)
      e_sex: 1 // 新增時預設性別為男生 (1)
    };
    
    setModalData(initialData);
    setIsEdit(!!employee);
    setShowModal(true);

    // 如果有現有的 e_photo，設置為圖片預覽
  if (initialData.e_photo) {
    setPreviewUrl(`/${initialData.e_photo}`); // 假設圖片是存儲在 /uploads 目錄中
  } else {
    setPreviewUrl(null); // 如果沒有 e_photo，清除預覽
  }
};
  const handleArchive = async () => {
    if (!archiveData.arriveat.trim()) {
      setMessage('請輸入屆別');
      return;
    }

    if (!window.confirm(`確定要將社別的社友資料歸檔到第 ${archiveData.arriveat} 屆嗎？`)) {
      return;
    }

    if (!token) {
      setMessage('未找到驗證信息，請重新登錄');
      return;
    }

    try {
      const response = await axios.post('/employees/archive', {
        arriveat: archiveData.arriveat,
        e_ssid: user?.e_ssid,
        p_edit_uid: user?.e_id
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      setMessage(`歸檔成功！已將 ${response.data.affectedRows} 筆資料歸檔到第 ${archiveData.arriveat} 屆`);
      setArchiveModal(false);
      setArchiveData({ arriveat: '' });
      fetchData(); // 重新載入資料
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      console.error('Error archiving employees:', error);
      setMessage('歸檔失敗！' + (error.response?.data?.message || ''));
      setTimeout(() => setMessage(''), 3000);
    }
  };

  const handleDelete = async (employeeId, employeeName) => {
    if (!window.confirm(`確定要刪除 ${employeeName} 的資料嗎？此操作無法復原。`)) {
      return;
    }

    if (!token) {
      setMessage('未找到驗證信息，請重新登錄');
      return;
    }

    try {
      await axios.delete(`/employees/${employeeId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      setMessage('刪除成功！');
      fetchData(); // 重新載入資料
      setTimeout(() => setMessage(''), 2000);
    } catch (error) {
      console.error('Error deleting employee:', error);
      
      // 處理不同類型的錯誤
      let errorMessage = '刪除失敗！';
      if (error.response?.status === 403) {
        const code = error.response.data.code;
        if (code === 'CROSS_STORE_DELETE_DENIED') {
          errorMessage = `權限不足：${error.response.data.message}`;
        } else {
          errorMessage = `權限不足：${error.response.data.message || '您沒有刪除權限'}`;
        }
      } else if (error.response?.status === 401) {
        errorMessage = '登入已過期，請重新登入';
      } else if (error.response?.status === 400 && error.response.data.code === 'SELF_DELETE_DENIED') {
        errorMessage = '無法刪除自己的帳號';
      } else if (error.response?.data?.message) {
        errorMessage = `刪除失敗：${error.response.data.message}`;
      }
      
      setMessage(errorMessage);
      setTimeout(() => setMessage(''), 4000); // 延長顯示時間以便閱讀錯誤訊息
    }
  };

  const handleSaveOrUpdate = async () => {
    const cleanedFormData = Object.fromEntries(
      Object.entries(modalData).map(([key, value]) => [key, value === '' ? null : value])
    );
    
    // 新增用戶時設定預設值
    if (!isEdit) {
      // 如果 e_group 沒填或為空，預設為 5 (社友)
      if (!cleanedFormData.e_group || cleanedFormData.e_group === null) {
        cleanedFormData.e_group = '5';
      }
      
      // 如果 e_position 沒填或為空，預設為 1 (一般社友職位)
      if (!cleanedFormData.e_position || cleanedFormData.e_position === null) {
        cleanedFormData.e_position = 1;
      }
    }
    
    if (!token) {
      setMessage('未找到驗證信息，請重新登錄');
      return;
    }
  
    try {
      if (isEdit) {
        // 編輯現有的社友
        await axios.put(`/employees/${modalData.e_id}`, cleanedFormData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setMessage('更新成功！');
      } else {
        // 新增新社友
        await axios.post('/employees', cleanedFormData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setMessage('新增成功！');
      }
  
      // 更新表格數據並關閉彈窗
      setShowModal(false);
      fetchData(); // 更新整個表格數據
  
      // 2 秒後清除成功消息
      setTimeout(() => setMessage(''), 2000);
    } catch (error) {
      if (error.response) {
        console.error(isEdit ? 'Error updating data:' : 'Error adding data:', error.response.data);
        setMessage(`${isEdit ? '更新' : '新增'}失敗: ${error.response.data.message}`);
      } else {
        console.error(isEdit ? 'Error updating data:' : 'Error adding data:', error);
        setMessage(`${isEdit ? '更新' : '新增'}失敗！`);
      }
    }
  };

  const handleUploadSuccess = (fileName, columnName) => {
    console.log(`上傳成功的檔案名稱: ${fileName}, 欄位: ${columnName}`);
    setModalData((prevData) => ({
      ...prevData,
      [columnName]: fileName, // 僅更新指定欄位
    }));
    // alert(`${columnName} 照片上傳成功！`);
  };

  // 照片移除成功回調
  const handleRemoveSuccess = (columnName) => {
    console.log(`移除成功的欄位: ${columnName}`);
    setModalData((prevData) => ({
      ...prevData,
      [columnName]: null, // 清空指定欄位
    }));
  };
  
  
  // const handleFileChange = (event) => {

  //   setUploadStatus('');
  //   setSuccessMessage('');
  //   const file = event.target.files[0];

    
  //   if (!file) return;

  //   if (file.size > 10 * 1024 * 1024) { // 5MB 限制
  //     setUploadStatus('文件大小不能超过 5MB');
  //     return;
  //   }

  //   setSelectedFile(file);

  //   // 使用 FileReader 生成圖片預覽
  //   const reader = new FileReader();
  //   reader.onloadend = () => {
  //     setPreviewUrl(reader.result); // 設置圖片預覽
  //   };
  //   reader.readAsDataURL(file); // 將文件讀取為 base64 編碼
  // };

  // 文件上傳處理
  // const handleFileUpload = async (e) => {
  //   const file = e.target.files[0];
  //   if (!file) return;

  //   const formData = new FormData();
  //   //console.log('e_id before upload:', modalData.e_id);

  //   formData.append('photo', file);
  //   formData.append('e_id', modalData.e_id); // 確保將 e_id 一同附加到 FormData
  //   formData.append('fileCategory', 'member'); // 你可以传递 'member' 或 'EDM' 根据需要改变

  //   try {
  //     const response = await axios.post(`/upload-photo?e_id=${modalData.e_id}`,  formData, {
  //       headers: {
  //         'Authorization': `Bearer ${token}`,
  //         'Content-Type': 'multipart/form-data',
  //       },
  //     });

  //     const filePath = response.data.filePath; // 從後端獲取文件路徑
  //     const fileName = filePath.split('/').pop(); // 提取文件名
  //     console.error('path',filePath);
  //     console.error('path',fileName);

  //     // 更新 modalData 的 e_photo 字段
  //     setModalData((prevData) => ({
  //       ...prevData,
  //       e_photo: fileName,
  //     }));

  //     setSuccessMessage('照片上傳成功！');
  //   } catch (error) {
  //     console.error('照片上傳失敗', error);
  //     setUploadStatus('照片上傳失敗！');
  //   }
  // };

  return (
    <div className="container-fluid mt-4" style={{ padding: isMobile ? '12px' : '20px' }}>
       {/* 顯示成功消息 */}
    {successMessage && (
      <div className="alert alert-success" role="alert">
        {successMessage}
      </div>
    )}
      {/* 搜尋框 */}
      <Row className="mb-3">
        <Col xs={12}>
          <Form.Control
            type="text"
            placeholder={isMobile ? "搜尋..." : "搜尋姓名、手機或組別..."}
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className={isMobile ? 'form-control-lg' : ''}
            style={{
              padding: isMobile ? '12px' : '10px',
              fontSize: isMobile ? '16px' : '14px'
            }}
          />
        </Col>
      </Row>

      {/* 按鈕群組 */}
      <Row className="mb-3 g-2">
        <Col xs={6} md={2}>
          <Button
            onClick={() => handleOpenModal()}
            className="w-100"
            size={isMobile ? 'lg' : 'md'}
          >
            新增
          </Button>
        </Col>
        <Col xs={6} md={2}>
          <Button
            onClick={() => {
              if (tableData && tableData.length > 0) {
                downloadExcel(tableData, 'employees', `資料_${new Date().toISOString().slice(0, 10)}.xlsx`);
              } else {
                alert('沒有資料可供下載');
              }
            }}
            className="w-100"
            size={isMobile ? 'lg' : 'md'}
          >
            下載
          </Button>
        </Col>
        <Col xs={6} md={2}>
          <Button
            variant="info"
            onClick={() => setBirthdayModal(true)}
            className="w-100"
            size={isMobile ? 'lg' : 'md'}
          >
            壽星名單
          </Button>
        </Col>
        <Col xs={6} md={2}>
          <Button
            variant="warning"
            onClick={handleBatchEditOpen}
            className="w-100"
            size={isMobile ? 'lg' : 'md'}
          >
            批次編輯
          </Button>
        </Col>
        {canEditRole && (
          <Col xs={12} md={2}>
            <Button
              variant="warning"
              onClick={() => setArchiveModal(true)}
              className="w-100"
              size={isMobile ? 'lg' : 'md'}
            >
              屆別歸檔
            </Button>
          </Col>
        )}
      </Row>


      {/* 狀態和職位篩選 */}
      <Row className="mb-3">
        <Col xs={12}>
          <Form.Select
            value={filterGroup}
            onChange={(e) => setFilterGroup(e.target.value)}
            className={isMobile ? 'form-select-lg' : ''}
            style={{
              fontSize: isMobile ? '16px' : '14px',
              padding: isMobile ? '12px' : '8px'
            }}
          >
            <option value="">全部類別</option>
            {mainempOptions.map((option) => (
              <option key={option.em_id} value={option.em_id}>
                {option.em_name}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Row>


      {message && (
        <Alert variant="success" onClose={() => setMessage('')} dismissible>
          {message}
        </Alert>
      )}

      <style>{tableStyles}</style>

      {/* 手機版：卡片視圖 */}
      {isMobile ? (
        <div>
          {tableData.map((employee, index) => (
            <Card key={employee.e_id} className="mb-3 shadow-sm">
              <Card.Body>
                <Row>
                  <Col xs={4} className="text-center">
                    <img
                      src={
                        employee.e_photo
                          ? `/uploads/member/${employee.e_photo}`
                          : '/uploads/member/default.jpg'
                      }
                      alt="社友相片"
                      style={{
                        width: '80px',
                        height: '106px',
                        objectFit: 'cover',
                        borderRadius: '8px'
                      }}
                    />
                  </Col>
                  <Col xs={8}>
                    <h6 className="mb-2">
                      <Badge bg="primary">#{index + 1}</Badge>{' '}
                      <strong>{employee.e_name || '未填寫'}</strong>
                    </h6>
                    <div className="mb-1">
                      <small className="text-muted">職位：</small>
                      <span className="ms-1">{employee.position_title || '未設定'}</span>
                    </div>
                    <div className="mb-1">
                      <small className="text-muted">手機：</small>
                      <span className="ms-1">{employee.e_mobile || '未填寫'}</span>
                    </div>
                    <div className="mb-1">
                      <small className="text-muted">組別：</small>
                      <span className="ms-1">{employee.e_set || '-'}</span>
                      {employee.e_set_position && (
                        <span className="ms-1 text-muted">({employee.e_set_position})</span>
                      )}
                    </div>
                    <div className="mb-1">
                      <small className="text-muted">生日：</small>
                      <span className="ms-1">{employee.e_birthday || '未填寫'}</span>
                    </div>
                    <div className="mb-1">
                      <small className="text-muted">性別：</small>
                      <span className="ms-1">{employee.e_sex === 1 ? '男' : employee.e_sex === 2 ? '女' : '未設定'}</span>
                    </div>
                  </Col>
                </Row>

                {/* 操作按鈕 */}
                <Row className="mt-3 g-2">
                  <Col xs={12}>
                    <Button
                      variant="primary"
                      size="lg"
                      className="w-100"
                      onClick={() => handleOpenModal(employee)}
                    >
                      📝 編輯詳細資料
                    </Button>
                  </Col>
                  {canDelete && (
                    <Col xs={12}>
                      <Button
                        variant="danger"
                        size="lg"
                        className="w-100"
                        onClick={() => handleDelete(employee.e_id, employee.e_name)}
                      >
                        🗑️ 刪除
                      </Button>
                    </Col>
                  )}
                </Row>
              </Card.Body>
            </Card>
          ))}
        </div>
      ) : (
        // 桌面版：表格視圖
        <div className="table-responsive">
        <Table striped bordered hover variant="dark" className="table-striped table-dark resizable-table">
          <thead>
            <tr><th style={{ width: '60px', resize: 'horizontal', overflow: 'hidden' }} onClick={() => handleSort('id')}>ID {renderSortIcon('id')}</th><th style={{ width: '80px', resize: 'horizontal', overflow: 'hidden' }}>相片</th><th style={{ width: '4cm', resize: 'horizontal', overflow: 'hidden' }} onClick={() => handleSort('e_name')}>姓名 {renderSortIcon('e_name')}</th><th style={{ width: '5cm', resize: 'horizontal', overflow: 'hidden' }} onClick={() => handleSort('position_title')}>職位 {renderSortIcon('position_title')}</th><th style={{ width: '120px', resize: 'horizontal', overflow: 'hidden' }} onClick={() => handleSort('e_set')}>組別 {renderSortIcon('e_set')}</th><th style={{ width: '140px', resize: 'horizontal', overflow: 'hidden' }} onClick={() => handleSort('e_set_position')}>組別職稱 {renderSortIcon('e_set_position')}</th><th style={{ width: '5cm', resize: 'horizontal', overflow: 'hidden' }} onClick={() => handleSort('e_mobile')}>手機 {renderSortIcon('e_mobile')}</th><th style={{ width: '5cm', resize: 'horizontal', overflow: 'hidden' }} onClick={() => handleSort('e_birthday')}>生日 {renderSortIcon('e_birthday')}</th><th style={{ width: '80px', resize: 'horizontal', overflow: 'hidden' }} onClick={() => handleSort('e_sex')}>性別 {renderSortIcon('e_sex')}</th><th style={{ width: '10cm', resize: 'horizontal', overflow: 'hidden' }} onClick={() => handleSort('e_address2')}>通訊地址 {renderSortIcon('e_address2')}</th><th style={{ width: canDelete ? '150px' : '100px', resize: 'horizontal', overflow: 'hidden' }}>Actions</th></tr>
          </thead>
          <tbody>
            {tableData.map((employee, index) => (
              <tr key={employee.e_id}>
                <td>{index + 1}</td>
                <td>
                  <img
                    src={
                      employee.e_photo
                        ? `/uploads/member/${employee.e_photo}`
                        : '/uploads/member/default.jpg'
                    }
                    alt="社友相片"
                    style={{ width: '60px', height: '80px'}}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={employee.e_name || ''} // Ensures `value` is not `null`
                    onChange={(e) => handleInputChange(e, employee.e_id, 'e_name')}
                    className="form-control"
                  />
                </td>
                <td>
                  <Form.Select
                    value={employee.position_title || ''}
                    onChange={(e) => handleInputChange(e, employee.e_id, 'position_title')}
                    className="form-control"
                  >
                    <option value="">請選擇職位</option>
                    {positions.map((position) => (
                      <option key={position.s_id} value={position.s_name}>
                        {position.s_name}
                      </option>
                    ))}
                  </Form.Select>
                </td>
                <td>
                  <input
                    type="text"
                    value={employee.e_set || ''} // 確保 `value` 不為 `null`
                    onChange={(e) => handleInputChange(e, employee.e_id, 'e_set')}
                    className="form-control"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={employee.e_set_position || ''} // 確保 `value` 不為 `null`
                    onChange={(e) => handleInputChange(e, employee.e_id, 'e_set_position')}
                    className="form-control"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={employee.e_mobile || ''} // 確保 `value` 不為 `null`
                    onChange={(e) => handleInputChange(e, employee.e_id, 'e_mobile')}
                    className="form-control"
                  />
                </td>
                <td>
                  <input
                    type="date"
                    value={employee.e_birthday || ''} // 確保 `value` 不為 `null`
                    onChange={(e) => handleInputChange(e, employee.e_id, 'e_birthday')}
                    className="form-control"
                  />
                </td>
                <td>
                  <Form.Select
                    value={employee.e_sex || ''}
                    onChange={(e) => handleInputChange(e, employee.e_id, 'e_sex')}
                    className="form-control"
                  >
                    <option value="">請選擇</option>
                    <option value="1">男</option>
                    <option value="2">女</option>
                  </Form.Select>
                </td>
                <td>
                  <input
                    type="text"
                    value={employee.e_address2 || ''} // 確保 `value` 不為 `null`
                    onChange={(e) => handleInputChange(e, employee.e_id, 'e_address2')}
                    className="form-control"
                  />
                </td>
                
                <td>
                  <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '5px' }}>
                    <Button
                      style={{
                        backgroundColor: employee.saveStatus === 'saved' ? 'green' : employee.hasChanges ? 'red' : 'gray',
                        color: 'white',
                        padding: '5px 10px',
                        fontSize: '12px',
                        border: 'none',
                        minWidth: '60px'
                      }}
                      onClick={() => handleSave(employee.e_id)}
                    >
                      儲存
                    </Button>
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={() => handleOpenModal(employee)}
                      style={{
                        color: 'white',
                        padding: '5px 10px',
                        fontSize: '12px',
                        minWidth: '60px'
                      }}
                    >
                      編輯
                    </Button>
                    {canDelete && (
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => handleDelete(employee.e_id, employee.e_name)}
                        style={{
                          color: 'white',
                          padding: '5px 10px',
                          fontSize: '12px',
                          minWidth: '60px'
                        }}
                      >
                        刪除
                      </Button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      )}

      {/* 新增/編輯 Modal */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        fullscreen={isMobile ? true : false}
        size={isMobile ? undefined : 'lg'}
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: isMobile ? '18px' : '20px' }}>
            {isEdit ? '編輯社友' : '新增社友'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: isMobile ? '16px' : '14px' }}>
          <Form>
          <Form.Group style={{ display: 'none' }}>
              <Form.Label>社別</Form.Label>
              <Form.Control
                type="text"
                name="e_ssid"
                value={modalData?.e_ssid || ''}
                onChange={handleModalInputChange}
                readOnly // 禁止用戶編輯此欄位
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>姓名</Form.Label>
              <Form.Control
                type="text"
                name="e_name"
                value={modalData?.e_name || ''}
                onChange={handleModalInputChange}
              />
            </Form.Group>
            <Form.Group>
            <Form.Label>職位</Form.Label>
            <Form.Select
              name="position_title"
              value={modalData?.position_title || (positions.length > 0 ? positions[0].s_name : '')}
              onChange={handleModalInputChange}
            >
              <option value="">請選擇職位</option>
              {positions.map((position) => (
                <option key={position.s_id} value={position.s_name}>
                  {position.s_name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group>
          <Form.Label>性別</Form.Label>
          <Form.Select
            name="e_sex"
            value={modalData?.e_sex ?? 1}  // 預設值為 1 代表男生
            onChange={handleModalInputChange}
          >
            <option value="1">男生</option>
            <option value="2">女生</option>
          </Form.Select>
        </Form.Group>


        <Form.Group>
  <Form.Label>生日</Form.Label>
  <Form.Control
    type="date"
    name="e_birthday"
    value={modalData?.e_birthday || ''}  // 預設值為 '2000-01-01'
    onChange={handleModalInputChange}
  />
</Form.Group>
<Form.Group>
  <Form.Label>身份證</Form.Label>
  <Form.Control
    type="text"
    name="e_UID"
    value={modalData?.e_UID || ''}
    onChange={handleModalInputChange}
  />
</Form.Group>

<Form.Group>
  <Form.Label>籍貫</Form.Label>
  <Form.Control
    type="text"
    name="sql_title1"
    value={modalData?.sql_title1 || ''}
    onChange={handleModalInputChange}
  />
</Form.Group>

<Form.Group>
  <Form.Label>學歷</Form.Label>
  <Form.Control
    type="text"
    name="sql_title2"
    value={modalData?.sql_title2 || ''}
    onChange={handleModalInputChange}
  />
</Form.Group>

<Form.Group>
  <Form.Label>入社時間</Form.Label>
  <Form.Control
    type="date"
    name="e_join_date"
    value={modalData?.e_join_date || ''}
    onChange={handleModalInputChange}
  />
</Form.Group>

<Form.Group>
  <Form.Label>最後繳費日期</Form.Label>
  <Form.Control
    type="date"
    name="e_payment_date"
    value={modalData?.e_payment_date || ''}
    onChange={handleModalInputChange}
  />
</Form.Group>

<Form.Group>
  <Form.Label>結婚記念日</Form.Label>
  <Form.Control
    type="date"
    name="e_marry"
    value={modalData?.e_marry || ''}
    onChange={handleModalInputChange}
  />
</Form.Group>

<Form.Group>
  <Form.Label>葷素食</Form.Label>
  <Form.Select
    name="e_foodType"
    value={modalData?.e_foodType || ''}
    onChange={handleModalInputChange}
  >
    <option value="">請選擇</option>
    <option value="1">葷</option>
    <option value="2">素</option>
  </Form.Select>
</Form.Group>


<Form.Group>
  <Form.Label>衣服尺碼</Form.Label>
  <Form.Control
    type="text"
    name="e_size"
    value={modalData?.e_size || ''}
    onChange={handleModalInputChange}
  />
</Form.Group>

<Form.Group>
  <Form.Label>住家電話</Form.Label>
  <Form.Control
    type="text"
    name="e_tel"
    value={modalData?.e_tel || ''}
    onChange={handleModalInputChange}
  />
</Form.Group>

<Form.Group>
  <Form.Label>公司電話</Form.Label>
  <Form.Control
    type="text"
    name="e_tel1"
    value={modalData?.e_tel1 || ''}
    onChange={handleModalInputChange}
  />
</Form.Group>

<Form.Group>
  <Form.Label>公司傳真</Form.Label>
  <Form.Control
    type="text"
    name="e_fax"
    value={modalData?.e_fax || ''}
    onChange={handleModalInputChange}
  />
</Form.Group>

<Form.Group>
  <Form.Label>手機</Form.Label>
  <Form.Control
    type="text"
    name="e_mobile"
    value={modalData?.e_mobile || ''}
    onChange={handleModalInputChange}
  />
</Form.Group>

<Form.Group>
  <Form.Label>住家郵編</Form.Label>
  <Form.Control
    type="text"
    name="e_zip"
    value={modalData?.e_zip || ''}
    onChange={handleModalInputChange}
  />
</Form.Group>

<Form.Group>
  <Form.Label>住家地址</Form.Label>
  <Form.Control
    type="text"
    name="e_address"
    value={modalData?.e_address || ''}
    onChange={handleModalInputChange}
  />
</Form.Group>

<Form.Group>
  <Form.Label>公司郵編</Form.Label>
  <Form.Control
    type="text"
    name="e_zip1"
    value={modalData?.e_zip1 || ''}
    onChange={handleModalInputChange}
  />
</Form.Group>

<Form.Group>
  <Form.Label>公司地址</Form.Label>
  <Form.Control
    type="text"
    name="e_address1"
    value={modalData?.e_address1 || ''}
    onChange={handleModalInputChange}
  />
</Form.Group>

<Form.Group>
  <Form.Label>通訊郵編</Form.Label>
  <Form.Control
    type="text"
    name="e_zip2"
    value={modalData?.e_zip2 || ''}
    onChange={handleModalInputChange}
  />
</Form.Group>

<Form.Group>
  <Form.Label>通訊地址</Form.Label>
  <Form.Control
    type="text"
    name="e_address2"
    value={modalData?.e_address2 || ''}
    onChange={handleModalInputChange}
  />
</Form.Group>

<Form.Group>
  <Form.Label>組別</Form.Label>
  <Form.Control
    type="text"
    name="e_set"
    value={modalData?.e_set || ''}
    onChange={handleModalInputChange}
  />
</Form.Group>

<Form.Group>
  <Form.Label>組別職稱</Form.Label>
  <Form.Control
    type="text"
    name="e_set_position"
    value={modalData?.e_set_position || ''}
    onChange={handleModalInputChange}
  />
</Form.Group>

<Form.Group>
  <Form.Label>社長年度標語</Form.Label>
  <Form.Control
    type="text"
    name="e_slogan"
    value={modalData?.e_slogan || ''}
    onChange={handleModalInputChange}
  />
</Form.Group>

<Form.Group>
  <Form.Label>公司名稱</Form.Label>
  <Form.Control
    type="text"
    name="e_comp_name"
    value={modalData?.e_comp_name || ''}
    onChange={handleModalInputChange}
  />
</Form.Group>

<Form.Group>
  <Form.Label>公司職稱</Form.Label>
  <Form.Control
    type="text"
    name="e_comp_position"
    value={modalData?.e_comp_position || ''}
    onChange={handleModalInputChange}
  />
</Form.Group>

<Form.Group>
  <Form.Label>公司網站</Form.Label>
  <Form.Control
    type="text"
    name="e_comp_web"
    value={modalData?.e_comp_web || ''}
    onChange={handleModalInputChange}
  />
</Form.Group>

<Form.Group>
  <Form.Label>公司排序</Form.Label>
  <Form.Control
    type="number"
    name="e_comp_sort"
    value={modalData?.e_comp_sort || ''}
    onChange={handleModalInputChange}
  />
</Form.Group>

<Form.Group>
  <Form.Label>公司開放狀態</Form.Label>
  <Form.Control
    type="text"
    name="e_comp_open"
    value={modalData?.e_comp_open || ''}
    onChange={handleModalInputChange}
  />
</Form.Group>

<Form.Group>
  <Form.Label>公司優惠券</Form.Label>
  <Form.Control
    type="text"
    name="e_comp_coupon"
    value={modalData?.e_comp_coupon || ''}
    onChange={handleModalInputChange}
  />
</Form.Group>

<Form.Group>
  <Form.Label>營業資訊</Form.Label>
  <Form.Control
    type="text"
    name="sql_title4"
    value={modalData?.sql_title4 || ''}
    onChange={handleModalInputChange}
  />
</Form.Group>


<Form.Group>
  <Form.Label>電子郵件</Form.Label>
  <Form.Control
    type="text"
    name="e_email"
    value={modalData?.e_email || ''}
    onChange={handleModalInputChange}
  />
</Form.Group>

 <Form.Group>
      <Form.Label>社友類別</Form.Label>
      <Form.Control
        as="select"
        name="e_group"
        value={modalData?.e_group || '5'}
        onChange={handleModalInputChange}
      >
        <option value="">請選擇類別</option>
        {mainempOptions.map((option) => (
          <option key={option.em_id} value={option.em_id}>
            {option.em_name}
          </option>
        ))}
      </Form.Control>
    </Form.Group>

    <Form.Group>
  <Form.Label>推薦人</Form.Label>
  <Select
    name="e_recom_uid"
    value={relationEmployeeOptions.find((option) => option.value === modalData?.e_recom_uid) || ''}
    onChange={(selectedOption) =>
      handleModalInputChange({ target: { name: 'e_recom_uid', value: selectedOption ? selectedOption.value : '' } })
    }
    options={relationEmployeeOptions}
    placeholder="請選擇社友"
    isClearable
    isSearchable
  />
</Form.Group>

<Form.Group>
  <Form.Label>關連人</Form.Label>
  <Select
    name="e_relation_uid"
    value={relationEmployeeOptions.find((option) => option.value === modalData?.e_relation_uid) || ''}
    onChange={(selectedOption) =>
      handleModalInputChange({ target: { name: 'e_relation_uid', value: selectedOption ? selectedOption.value : '' } })
    }
    options={relationEmployeeOptions}
    placeholder="請選擇社友"
    isClearable
    isSearchable
  />
</Form.Group>

<Form.Group>
      <Form.Label>關連人稱謂</Form.Label>
      <Form.Control
        as="select"
        name="e_appellation"
        value={modalData?.e_appellation || ''} // 使用安全導航操作符
        onChange={handleModalInputChange}
      >
        <option value="">請選擇稱謂</option>
        {appellations.map((appellation) => (
          <option key={appellation.a_id} value={appellation.a_id}>
            {appellation.a_name}
          </option>
        ))}
      </Form.Control>
    </Form.Group>

<div>
{/* 個人相片上傳 - 需要先儲存社友資料才能上傳 */}
{modalData.e_id ? (
  <Form.Group className="mb-3">
    <Form.Label className="fw-bold">個人相片</Form.Label>
    <div className="d-flex justify-content-center">
      <PhotoUpload
        e_id={modalData.e_id}
        token={token}
        fileCategory="member"
        tableName="employees"
        columnName="e_photo"
        idColumn="e_id"
        currentFileName={modalData.e_photo}
        buttonText="上傳個人相片"
        onUploadSuccess={(fileName) => handleUploadSuccess(fileName, 'e_photo')}
        onRemoveSuccess={() => handleRemoveSuccess('e_photo')}
        onImageClick={(imageUrl) => {
          setLightboxImage(imageUrl);
          setIsLightboxOpen(true);
        }}
      />
    </div>
  </Form.Group>
) : (
  <Form.Group className="mb-3">
    <Form.Label className="fw-bold">個人相片</Form.Label>
    <div className="text-muted">請先儲存社友資料後才能上傳個人相片</div>
  </Form.Group>
)}

{/* EDM 照片上傳 - 需要先儲存社友資料才能上傳 */}
{modalData.e_id ? (
  <Form.Group className="mb-3">
    <Form.Label className="fw-bold">工商交流照片 (EDM)</Form.Label>
    <div className="d-flex justify-content-center">
      <PhotoUpload
        e_id={modalData.e_id}
        token={token}
        fileCategory="EDM"
        tableName="employees"
        columnName="EDM_photo"
        idColumn="e_id"
        currentFileName={modalData.EDM_photo}
        buttonText="上傳EDM照片"
        onUploadSuccess={(fileName) => handleUploadSuccess(fileName, 'EDM_photo')}
        onRemoveSuccess={() => handleRemoveSuccess('EDM_photo')}
        onImageClick={(imageUrl) => {
          setLightboxImage(imageUrl);
          setIsLightboxOpen(true);
        }}
      />
    </div>
  </Form.Group>
) : (
  <Form.Group className="mb-3">
    <Form.Label className="fw-bold">工商交流照片 (EDM)</Form.Label>
    <div className="text-muted">請先儲存社友資料後才能上傳EDM照片</div>
  </Form.Group>
)}

      {uploadStatus && <p>{uploadStatus}</p>}
      {successMessage && <p>{successMessage}</p>}
    </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            取消
          </Button>
          <Button variant="primary" onClick={handleSaveOrUpdate}>
            保存
          </Button>
        </Modal.Footer>
      </Modal>

      {/* 屆別歸檔 Modal */}
      <Modal
        show={archiveModal}
        onHide={() => setArchiveModal(false)}
        fullscreen={isMobile ? true : false}
      >
        <Modal.Header closeButton>
          <Modal.Title>屆別歸檔</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>請輸入屆別</Form.Label>
              <Form.Control
                type="text"
                placeholder="例如第28屆：直接打28"
                value={archiveData.arriveat}
                onChange={(e) => setArchiveData({ arriveat: e.target.value })}
              />
              <Form.Text className="text-muted">
                此操作將會把您社別中 e_group ≤ 5 且狀態為啟用的社友資料歸檔到 previous 資料表
              </Form.Text>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setArchiveModal(false)}>
            取消
          </Button>
          <Button variant="warning" onClick={handleArchive}>
            確認歸檔
          </Button>
        </Modal.Footer>
      </Modal>

      {/* 壽星名單 Modal */}
      <Modal
        show={birthdayModal}
        onHide={() => setBirthdayModal(false)}
        size="lg"
        fullscreen={isMobile ? true : false}
      >
        <Modal.Header closeButton>
          <Modal.Title>壽星名單</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <Form.Label>選擇月份</Form.Label>
            <Form.Select
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
            >
              <option value="">請選擇月份</option>
              <option value="1">1月</option>
              <option value="2">2月</option>
              <option value="3">3月</option>
              <option value="4">4月</option>
              <option value="5">5月</option>
              <option value="6">6月</option>
              <option value="7">7月</option>
              <option value="8">8月</option>
              <option value="9">9月</option>
              <option value="10">10月</option>
              <option value="11">11月</option>
              <option value="12">12月</option>
            </Form.Select>
          </div>
          <div className="mb-3">
            <Button variant="primary" onClick={handleBirthdayQuery} className="me-2">
              查詢
            </Button>
            {birthdayData.length > 0 && (
              <Button variant="success" onClick={downloadBirthdayExcel}>
                下載Excel
              </Button>
            )}
          </div>
          
          {birthdayData.length > 0 && (
            <div>
              <h5>{selectedMonth}月壽星名單</h5>
              {isMobile ? (
                // 手機版：卡片視圖
                <div>
                  {birthdayData.map((person, index) => (
                    <Card key={index} className="mb-3 shadow-sm">
                      <Card.Body>
                        <div className="d-flex align-items-center mb-2">
                          {person.e_line_picture_url && (
                            <img
                              src={person.e_line_picture_url}
                              alt={person.e_name}
                              className="rounded-circle me-3"
                              style={{
                                width: '48px',
                                height: '48px',
                                objectFit: 'cover',
                                border: '1px solid #dee2e6'
                              }}
                              onError={(e) => {
                                e.target.style.display = 'none';
                              }}
                            />
                          )}
                          <div>
                            <h6 className="mb-1">{person.e_name}</h6>
                            <small className="text-muted">
                              {person.store_name || '未知社別'} | {person.position_name || '未知職位'}
                            </small>
                          </div>
                        </div>
                        <div className="mt-2">
                          <Badge bg="info" className="p-2">
                            🎂 {person.birthday_display}
                          </Badge>
                        </div>
                      </Card.Body>
                    </Card>
                  ))}
                </div>
              ) : (
                // 桌面版：表格視圖
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>姓名</th>
                      <th>社別</th>
                      <th>職位</th>
                      <th>生日</th>
                    </tr>
                  </thead>
                  <tbody>
                    {birthdayData.map((person, index) => (
                      <tr key={index}>
                        <td>
                          <div className="d-flex align-items-center">
                            {person.e_line_picture_url && (
                              <img
                                src={person.e_line_picture_url}
                                alt={person.e_name}
                                className="rounded-circle me-2"
                                style={{
                                  width: '32px',
                                  height: '32px',
                                  objectFit: 'cover',
                                  border: '1px solid #dee2e6'
                                }}
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                }}
                              />
                            )}
                            <span>{person.e_name}</span>
                          </div>
                        </td>
                        <td>{person.store_name || '未知社別'}</td>
                        <td>{person.position_name || '未知職位'}</td>
                        <td>{person.birthday_display}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setBirthdayModal(false)}>
            關閉
          </Button>
        </Modal.Footer>
      </Modal>

      {/* 批次編輯 Modal */}
      <Modal
        show={batchEditModal}
        onHide={() => setBatchEditModal(false)}
        size="xl"
        fullscreen
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: isMobile ? '18px' : '20px' }}>
            批次編輯 - Excel風格表格
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <p className="text-info">
              💡 使用說明：
              <br />• 直接點擊任何欄位進行編輯
              <br />• 支援從Excel複製貼上 (Ctrl+C 複製，Ctrl+V 貼上)
              <br />• 社別、職位可輸入中文，系統會自動轉換
              <br />• 點擊欄位標題可排序
            </p>
            <hr />
            <div className="d-flex justify-content-between mb-3">
              <div>
                <Button 
                  variant="success" 
                  className="me-2"
                  onClick={handleBatchSave}
                  disabled={modifiedCount === 0}
                >
                  💾 儲存變更
                </Button>
                <Button 
                  variant="secondary" 
                  className="me-2"
                  onClick={handleBatchReset}
                >
                  🔄 重置
                </Button>
                <Button variant="info" onClick={() => setPasteDataModal(true)}>
                  📋 貼上資料
                </Button>
              </div>
              <div>
                <small className="text-muted">
                  共 {tableData.length} 筆資料 | 已修改: {modifiedCount} 筆
                </small>
              </div>
            </div>
          </div>

          {/* Excel風格可編輯表格 */}
          <div style={{ height: '60vh', overflow: 'auto' }}>
            <BatchEditTable
              data={batchEditData}
              onDataChange={handleBatchEditDataChange}
              onModifiedCountChange={handleModifiedCountChange}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setBatchEditModal(false)}>
            關閉
          </Button>
        </Modal.Footer>
      </Modal>

      {/* 貼上資料 Modal */}
      <Modal
        show={pasteDataModal}
        onHide={() => setPasteDataModal(false)}
        size="lg"
        fullscreen={isMobile ? true : false}
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: isMobile ? '16px' : '20px' }}>
            📋 社友資料批量修正 - 貼上資料
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <Alert variant="info">
              <Alert.Heading>📋 使用說明</Alert.Heading>
              <p><strong>輸入格式：</strong></p>
              <ul>
                <li>每行一筆資料</li>
                <li>基本格式：<code>員工ID 職位名稱</code></li>
                <li>完整格式：<code>員工ID 職位名稱 組別 組別職稱</code></li>
                <li>可用空白、Tab、逗號、分號分隔</li>
                <li>組別和組別職稱為可選項目</li>
              </ul>
              <p><strong>範例：</strong></p>
              <code>
                80 秘書<br/>
                100 社友 A組 組長<br/>
                200 理事 B組<br/>
                300 社友 C組 副組長
              </code>
            </Alert>
          </div>

          <Form.Group className="mb-3">
            <Form.Label><strong>貼上要修正的資料：</strong></Form.Label>
            <Form.Control
              as="textarea"
              rows={10}
              value={pasteText}
              onChange={(e) => setPasteText(e.target.value)}
              placeholder={`請貼上資料，例如：\n80 秘書\n100 社友 A組 組長\n200 理事 B組\n300 社友 C組 副組長`}
            />
          </Form.Group>

          <div className="mb-3">
            <Button
              variant="primary"
              onClick={handleParsePasteData}
              disabled={!pasteText.trim()}
              className="me-2"
            >
              🔍 解析資料
            </Button>
            <Button
              variant="outline-secondary"
              onClick={() => {
                setPasteText('');
                setParsedPasteData([]);
              }}
            >
              🗑️ 清空
            </Button>
          </div>

          {/* 解析結果預覽 */}
          {parsedPasteData.length > 0 && (
            <div className="mb-3">
              <h6>📊 解析結果預覽 ({parsedPasteData.length} 筆)：</h6>
              <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                <Table striped bordered hover size="sm">
                  <thead>
                    <tr>
                      <th>行號</th>
                      <th>員工ID</th>
                      <th>職位名稱</th>
                      <th>職位ID</th>
                      <th>組別</th>
                      <th>組別職稱</th>
                    </tr>
                  </thead>
                  <tbody>
                    {parsedPasteData.map((item, index) => (
                      <tr key={index}>
                        <td>{item.lineNumber}</td>
                        <td><Badge bg="info">{item.e_id}</Badge></td>
                        <td>{item.positionName}</td>
                        <td><Badge bg="success">{item.e_position}</Badge></td>
                        <td>{item.e_set ? <Badge bg="warning">{item.e_set}</Badge> : <span className="text-muted">-</span>}</td>
                        <td>{item.e_set_position ? <Badge bg="secondary">{item.e_set_position}</Badge> : <span className="text-muted">-</span>}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setPasteDataModal(false)}>
            關閉
          </Button>
          <Button
            variant="success"
            onClick={handleExecutePasteUpdate}
            disabled={parsedPasteData.length === 0 || pasteProcessing}
          >
            {pasteProcessing ? '處理中...' : '🚀 執行更新'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Lightbox 顯示區域 */}
      {isLightboxOpen && (
        <Lightbox
          mainSrc={lightboxImage}
          onCloseRequest={() => setIsLightboxOpen(false)}
          reactModalStyle={{
            overlay: { zIndex: 1060 },
            content: { zIndex: 1061 }
          }}
        />
      )}
    </div>
  );
}

export default EmployeeBatch;
